import { render, staticRenderFns } from "./aged_detail.vue?vue&type=template&id=4a179cc2&scoped=true"
import script from "./aged_detail.vue?vue&type=script&lang=js"
export * from "./aged_detail.vue?vue&type=script&lang=js"
import style0 from "./aged_detail.vue?vue&type=style&index=0&id=4a179cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a179cc2",
  null
  
)

export default component.exports